import React, { useRef } from "react";

const SpeedTable = ({ data, heading, head, des }) => {
  return (
    <div className="p-3 mt-2 newUiBody">
      <div
        style={{
          //   maxHeight: "500px",
          //   maxWidth: "500px",
          overflow: "auto",
          fontSize: "11px",
        }}
      >
        <table className="table glassTable ">
          <thead className="table-dark sticky-top">
            <tr>
              <th colSpan={5} style={{ fontSize: "15px" }}>
                {heading}
              </th>
            </tr>
            <tr>
              {head.map((o) => (
                <th>{o} </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data?.map((item, index) =>
              des.some((o) => item[o] === "ZZZ") ? null : (
                <tr key={index}>
                  {des.map((o, i) => (
                    <td key={i}>
                      {item[o] === Number(item[o])
                        ? item[o].toFixed(2)
                        : item[o]}
                    </td>
                  ))}
                </tr>
              ),
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SpeedTable;
